<!--
 * @Author: your name
 * @Date: 2021-09-15 11:40:44
 * @LastEditTime: 2022-11-15 15:10:06
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/zhejiangconsume/index.vue
-->
<template>
  <div ref="box" id="zhejiangsonsume">
    <div id="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220809-shijianchen-1.jpg"
        alt=""
      />
      <span @click="showRule" class="ruleBtn">活动说明</span>
    </div>
    <!-- <img
      src="https://source.qunarzz.com/site/images/wns/20220811-shijianchen-tip2.jpg"
    /> -->
    <div class="cardList">
      <div class="card" v-for="(item, index) in imgs" :key="index">
        <img @click="jump(item, index)"
          v-maidian="'card_' + index"
          :src="item.normal"
        />
        <img v-maidian="'card_' + index" @click="jump(item, index)" src="https://source.qunarzz.com/site/images/wns/20220809-shijianchen-card.png" class="card_icon" alt="">
      </div>
    </div>
    <!-- <img src="https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/26.jpg" alt=""> -->
    <div class="box">
      <video
        data-v-3b1260f5=""
        id="vido_one"
        controls="controls"
        webkit-playsinline=""
        src="https://source.qunarzz.com/site/images/wns/20221115-shijianchen-video.mp4"
        poster="https://source.qunarzz.com/site/images/wns/20221115-shijianchen-poster.jpeg"
        playsinline=""
        x5-video-player-type="h5"
        class="video__player poster"
      >
        抱歉，您的浏览器不支持内嵌视频
      </video>
      <div class="tit">魅力·滨湖</div>
      <div class="text">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;无锡市滨湖区，位于长江三角洲腹地，因濒临太湖而得名。滨湖境内有环太湖公路、京杭大运河、锡宜高速公路穿境而过，拥有世界殿堂级的湖泊风景。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;漫步在灵山胜境景区感受灵山文化园各类佛教胜景，环游横卧太湖西北岸的“鼋头渚”半岛，体验当代诗人郭沫若曾称赞“太湖佳绝处，毕竟在鼋头”的诗意风情。
      </div>
    </div>
    <div id="line">
      <div id="hotel">
        <div class="line_head">
          <img
            src="https://source.qunarzz.com/site/images/wns/20220809-shijianchen-tit1.png"
            alt=""
          />
        </div>
        <lineComp type="hotel" :lineList="hotelImg"></lineComp>
        <!-- <a
          href="https://touch.qunar.com/hotelcn/wuxi/q-%E6%BB%A8%E6%B9%96%E5%8C%BA?bd_source=travel_touch&city=%E6%97%A0%E9%94%A1&checkInDate=2022-08-08&checkOutDate=2022-08-09&cityUrl=wuxi&sort=0&localSearch=0&keywords=%E6%BB%A8%E6%B9%96%E5%8C%BA"
          v-maidian="'hotel_lookmore'"
          class="lookMore"
          >查看更多</a
        > -->
      </div>
      <div id="hot">
        <div class="line_head">
          <img
            src="https://source.qunarzz.com/site/images/wns/20220809-shijianchen-tit2.png"
            alt=""
          />
        </div>
        <lineComp2 type="hot" :lineList="hotImg"></lineComp2>
        <a
          href="https://touch.go.qunar.com/299940/sights?from=mobile"
          v-maidian="'hot_lookmore'"
          class="lookMore"
          >查看更多</a
        >
      </div>
      <div class="line">
        <div class="line_head">
          <img
            src="https://source.qunarzz.com/site/images/wns/20220809-shijianchen-tit3.png"
            alt=""
          />
        </div>
        <a
          :href="item.link"
          v-maidian="'line_' + index"
          v-for="(item, index) in zhelihaowan"
          :key="index"
          class="line_item clear"
        >
          <div class="line_item_lf">
            <img :src="item.url" alt="" />
          </div>
          <div class="line_item_rt">
            <div class="line_item_rt_tp">
              <div class="line_tit text-overflow">
                {{ item.title }}
              </div>
              <div class="tag">跟团游</div>
              <div class="des">全程0购物/纯玩/享全景</div>
            </div>
            <div class="line_item_rt_btm">
              <span class="price">{{ item.price }}</span>
              <span class="btn">点击抢购</span>
            </div>
          </div>
        </a>
        <a
          href="https://touch.travel.qunar.com/299940"
          v-maidian="'line_lookmore'"
          class="lookMore"
          >查看更多</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import lineComp from './components/line.vue';
import lineComp2 from './components/line2.vue';
import ruleDialog from './components/rule/index';
export default {
  components: {
    lineComp: lineComp,
    lineComp2,
  },
  data() {
    return {
      current: 0,
      tabs: ['浙里好玩', '躺平旅行', '热门景点', '攻略指南'],
      hotelImg: [
        [
          {
            headImg:
              'https://himg1.qunarzz.com/imgs/202205/17/C.93VgeGix-OWpP8v8i1024.jpg',
            price: 472,
            tag: '亲子酒店/网红打卡',
            desc: '无锡君来湖滨饭店',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=wuxi_41&type=0&checkInDate=2022-08-08&checkOutDate=2022-08-09',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-t1.jpg',
            price: 346,
            tag: '室内泳池/环境很好',
            desc: '无锡大饭店',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=wuxi_30&type=0&checkInDate=2022-08-09&checkOutDate=2022-08-10',
          },
        ],
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-t2.jpg',
            price: 810,
            tag: '网红打卡/室内泳池',
            desc: '无锡鲁能万豪酒店',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=wuxi_10550&type=0&checkInDate=2022-08-08&checkOutDate=2022-08-09',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-t3.jpg',
            price: 710,
            tag: '湖畔美居/园林建筑',
            desc: '无锡融创皇冠假日酒店',
            linkId:
              'https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=wuxi_11524&type=0&checkInDate=2022-08-08&checkOutDate=2022-08-09',
          },
        ],
      ],
      beautyImg: [
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/1.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/2.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/3.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/4.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/5.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/6.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/7.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/8.jpg',
        'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/imgs/meitu/9.jpg',
      ],
      hotImg: [
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-tt1.jpg',
            price: 85,
            tag: '5A景区',
            dec: '鼋头渚',
            desc: '太湖风光精华所在',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=2976803000&from=ios',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-tt2.jpg',
            price: 194,
            tag: '5A景区',
            dec: '灵山胜境',
            desc: '拜灵山大佛看佛教文化表演',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=3102524493&from=ios',
          },
        ],
        [
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-binhu-tt3.jpg',
            price: 130,
            tag: '',
            dec: '水浒城',
            desc: '央视《水浒传》的拍摄地',
            linkId:
              'http://touch.piao.qunar.com/touch/detail.htm?id=3964774790&from=ios',
          },
        ],
      ],
      zhelihaowan: [
        {
          url: 'https://source.qunarzz.com/site/images/wns/2022809-shijianchen-lun1.png',
          title: '江苏无锡3日 五钻酒店任选*1晚市区or太湖边+1晚拈花湾景区内',
          link: 'https://touch.dujia.qunar.com/p/item/3205451330?date=2022-09-03',
          price: '3444',
        },
        {
          url: 'https://source.qunarzz.com/site/images/wns/2022809-shijianchen-lun2.png',
          title: '2天轻松玩转无锡|纯玩+爸妈放心游',
          link: 'https://touch.dujia.qunar.com/p/item/1020800793?date=2022-08-10',
          price: '933',
        },
      ],
      disabledCard: [],
      imgs: [
        {
          normal:
            'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-hotel.png',
          disable: false,
          link: 'https://m.flight.qunar.com/shark/active/e57a79e12cf4fd67e1477bdcb9559c5b?bd_source=zthd_818880',
          grey: 'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/21.png',
        },
        {
          normal:
            'https://source.qunarzz.com/site/images/wns/20220809-shijianchen-ticket.png',
          grey: 'https://s.qunarzz.com/srmweb/qunaradv/zhejiangconsume/22.png',
          link: 'https://m.flight.qunar.com/shark/active/e57a79e12cf4fd67e1477bdcb9559c5b?bd_source=zthd_818880',
          disable: false,
        },
      ],
    };
  },
  mounted() {
    // let imgsstr = localStorage.getItem(this.getKey());
    // if (imgsstr) {
    //   this.imgs = JSON.parse(imgsstr);
    // }
  },
  methods: {
    getKey() {
      let _date = +new Date();
      if (_date > +new Date('2022/6/29 00:00:00')) {
        return 'zhejiangsonsume/imgs/new/7';
      } else {
        return 'zhejiangsonsume/imgs/new/6';
      }
    },
    toggle(index) {
      this.current = index;
      let boxList = ['line', 'hotel', 'hot', 'note-box'];
      this.$refs.box.scrollTop = document.getElementById(
        boxList[index],
      ).offsetTop;
    },
    showRule() {
      ruleDialog({});
    },
    jump(item, index) {
      location.href = item.link;
    },
  },
};
</script>

<style  lang='less' scoped='true'>
#zhejiangsonsume {
  overflow: auto;
  padding-bottom: 30px;
  height: 100vh;
  background-color: #bdd3f2;
}
#banner {
  height: 430px;
  overflow-y: hidden;
}
.cardList {
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-bottom: 21px;
  position: relative;
  .card {
    position: relative;
    .card_icon {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
    }
  }
  img {
    margin-bottom: 8px;
  }
}
img {
  display: block;
}
.tit {
  width: 160px;
  padding-bottom: 8px;
  color: #fff;
  font-size: 22px;
  margin-bottom: 18px;
  border-bottom: 1px solid #fff;
}
.box {
  width: calc(100% - 20px);
  margin: 0 auto;
  background: linear-gradient(0deg, #84b1fa 0%, #71a6f6 100%);
  border-radius: 20px;
  padding-top: 10px;
}
video {
  width: 332px;
  height: 217px;
}
#banner {
  position: relative;
}
.ruleBtn {
  position: absolute;
  right: 10px;
  top: 370px;
  width: 66px;
  height: 23px;
  background: rgba(61, 61, 61, .54);
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tit {
  margin: 8px auto;
}
.tabs {
  margin: 0 auto;
  margin-top: 35px;
  margin-bottom: 28px;
  position: sticky;
  top: 0;
  left: 0;
  width: calc(100% - 20px);

  z-index: 20;
  .tab-it {
    width: 80px;
    height: 28px;
    background: #fefeff;
    border-radius: 14px;
    display: flex;
    align-items: center;
    color: #008567;
    margin-right: 8px;
    float: left;
    justify-content: center;
    &.active {
      background: linear-gradient(0deg, #008a63 0%, #00d0a4 95%);
      color: #fff;
    }
  }
}
.text {
  padding: 15px;
  padding-top: 0;
  color: #fff;
  text-align: left;
  overflow-y: auto;
}
.line_head {
  width: calc(100% - 20px);
  margin: 25px auto 20px;
}
.line_item {
  width: calc(100% - 20px);
  background: #ffffff;
  border-radius: 10px;
  padding: 8px;
  box-sizing: border-box;
  margin: 0 auto;
  display: block;
  text-decoration: none;
  color: #333;
  margin-top: 10px;
  .line_tit {
    height: 32px;
    margin-bottom: 10px;
    line-height: 16px;
  }
  .tag {
    width: 55px;
    height: 18px;
    color: #007cff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 11px;
    background: linear-gradient(270deg, #faffff 0%, #d2dcff 100%);
    border-radius: 9px 0px 0px 9px;
  }
  .des {
    font-size: 11px;
    color: #666;
  }
  .price {
    color: #ff2f00;
    font-size: 18px;
    &:before {
      content: '￥';
      font-size: 9px;
      position: relative;
    }
    &:after {
      content: '起';
      font-size: 9px;
      position: relative;
    }
  }
  .line_item_rt_btm {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .btn {
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(-54deg, #ffaf61 0%, #f719a1 100%);
    border-radius: 11px;
    font-size: 11px;
    color: #fff;
    padding-left: 8px;
    padding-right: 8px;
  }
  .line_item_lf {
    float: left;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 120px;
      height: 144px;
    }
  }
  .line_item_rt {
    height: 144px;
    width: calc(100% - 130px);
    padding-top: 10px;
    box-sizing: border-box;
    text-align: left;
    float: right;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.lookMore {
  position: relative;
  color: #fff;
  padding-bottom: 2px;
  margin-top: 8px;
  display: block;
  text-decoration: none;
  &.white {
    color: #fff;
  }
  &:after {
    content: '';
    display: block;
    width: 64px;
    height: 2px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    margin-left: -32px;
    bottom: 0;
  }
  &.white:after {
    background-color: #fff;
  }
}
* {
  box-sizing: border-box;
}
#note {
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 10px;

  background: linear-gradient(0deg, #008a63 0%, #00d0a4 95%);
  margin-bottom: 42px;
}
.note_it {
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  display: block;
  text-decoration: none;
  color: #999;
  border-radius: 5px;
  margin-bottom: 11px;
  .note_img {
    float: left;
    img {
      width: 123px;
      height: 86px;
    }
  }
  .note_cont {
    padding: 10px;
    float: left;
    box-sizing: border-box;
    width: calc(100% - 123px);
    text-align: left;
    height: 85px;
  }
  .note_tit {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #747474;
    line-height: 18px;
    margin-bottom: 6px;
    height: 18px;
    -webkit-line-clamp: 1;
  }
  .note_text {
    color: #747474;
    margin-bottom: 8px;
    font-size: 9px;
    height: 24px;
    line-height: 12px;
  }
  .note_foot {
    text-align: right;
    font-size: 11px;
    color: #747474;
  }
}
.swiper {
  height: 200px;
}
</style>
